import React from 'react';
import { Row, Col } from 'react-bootstrap';

import p1 from "../assets/passage/p1.jpg";
import p2 from "../assets/passage/p2.jpg";
import p3 from "../assets/passage/p3.jpg";
import p4 from "../assets/passage/p4.jpg";

import img1 from "../assets/img/bandeau.jpg";


export const Passage = () => {
  return (
    <>

      <div className="banner-titre-container">
        <img src={img1} className="back-img" />
        <div className='over-banner'>
          <div className='info-banner'>
            <h1 className='banner-title'> Passage d'âme ... <br />

              Accompagner l'âme qui part ...<br />
              Réconforter ceux qui restent ...  <br /></h1>
          </div>
        </div>
      </div>


      <div className='block-container passage-container bottom-space side-space-margin top-space-margin'>
        <Row>
          <Col xs={12} lg={8}>
            <div className='central-block central-block-margin'>
              <div className='meditation-titre'>
                <h2>La Passeuse d'Ame a une double mission :</h2>
                <h3 >Aider l'âme en partance ou déjà partie<br />
                  Réconforter ceux qui restent.</h3>
              </div>
              <br />

              <p>Naissance - décès ... moments d'émotion intense qui éprouvent nos croyances.  <br /><br />
                La vie, c'est quoi ? D'où vient-elle ? Où est passée la vie de celui qui vient de nous quitter ? Qui va nous guider hors de nos tumultes intérieurs vers cet espace  paisible, capable d'absorber <em>toute </em>notre douleur ?   <br /><br />
                C'est le rôle de la <strong>Passeuse d'Ame</strong> d'apaiser et d'aider lors du passage délicat qu'est la fin de vie. C'est <em>elle</em> qui connaît la difficulté de passer d'un  état incarné au non-incarné et vice-versa... C'est <em>elle</em> qui capte les inquiétudes des âmes dans le passage, et c'est encore <em>elle</em> qui trouve les mots pour réconforter, bercer, expliquer, guider.   <br /><br />
                La Passeuse d'Ame crée un climat de confiance pour permettre  un dialogue d'âme à âme avec l'Etre en partance, ou ayant déjà quitté son corps ... peu importe depuis quand.   <br /><br />
                En effet, la personne décédée a parfois du mal à quitter le plan terrestre, surtout en cas de décès accidentel. Son âme ne comprend pas, ou n'accepte pas, la mort de son corps physique. Elle a grand besoin d'être rassurée, bercée, éclairée et accompagnée pour accepter de lâcher prise et oser avancer vers des plans de conscience plus élevés.    <br /><br />
                D'autres fois, l'âme d'un proche cherche  à nous contacter, pour dire ce qu'elle n'a jamais osé nous dire de son vivant, pour nous faire sentir tout son amour. Elle se glisse alors dans nos pensées, nos rêves, nos sentiments.   <br /><br />
                Enfin, il arrive que <em>nous</em>  n'acceptions pas le départ d'un proche. Nous le retenons inconsciemment, refusant  de le laisser partir  et poursuivre sa route en tant qu'âme libre et libérée.   <br /><br />

                Ce sont là des moments où il m'est permis d'intervenir ponctuellement. En servant de <strong>pont de lumière</strong>, de voie de communication spirtuelle entre la famille terrestre et l'âme du défunt<strong>,</strong> je facilite l'échange entre  deux mondes vibratoires différents, pour apporter les éclairages nécessaires à l'acception de part et d'autre.

                <br /> <br />Avant le départ, le Passage d'Âme :  <br /><br />
                <ul>
                  <li>Prépare, calme et rassure la personne qui s'apprête à quitter le plan terrestre. </li>
                  <li>L'aide à dépasser ses regrets, sa culpabilité et à lâcher prise</li>
                  <li ><span>Accompagne l'âme du défunt, l'apaise,  l'oriente, l'encourage à  s'élever pour retrouver ses Guides et sa famille d'âme.</span></li>
                </ul>
                <br />
                Pendant et après, le Passage d'Âme :  <br /><br />
                <ul>

                  <span >
                    <li><span   >Aide à  comprendre et à accepter le départ de l'être aimé. </span></li>
                    <li><span   >Adoucit l'étape du deuil</span>.</li>
                    <li><span   >Allège  la douleur grâce à une nouvelle compréhension des cycles d'incarnations et de leur raison d'être.</span></li>
                    <li><span> Aide à grandir spirituellement.</span></li>
                    <li><span   >Rend palpable les liens d'Amour qui unissent les deux mondes.</span></li>

                  </span>
                </ul>
              </p>
            </div>
          </Col>
          <Col xs={12} lg={4}>
            <div className='right-block meditation-titre passage-container'>
              <p>
                <em>"Les morts ne sont pas morts, ils sont seulement invisibles à nos yeux.</em>"  <br /><br />
                <em>"La mort n'est pas obscurité, c'est une lampe qui s'éteint car le jour se lève."</em>  <br /><br />
                <img src={p1} />  <br /><br />
                <em>"Tout finit afin que tout recommence, tout meurt afin que tout vive."</em> <br />- Jean Henri Fabre   <br /><br />
                <img src={p2} /><br /><br />
                <em>"Puisque je t'aime, je peux te laisser partir ... vois-tu, je sais que nous sommes reliés par l'Amour, au-delà du Temps et de l'Espace ... et que vie après vie, nous nous retrouverons .."</em><br /> - J.K.T.  <br /><br />
                <img src={p3} /><br /><br />
                <span><strong>Prière de Saint Augustin</strong> :</span>  <br /><br />
                "Je suis seulement passé dans la pièce d'à-côté.   <br /><br />
                Je suis moi. Vous êtes vous. Ce que j'étais pour vous, je le suis toujours.  <br /><br />
                Donnez-moi le nom que vous m'avez toujours donné. Parlez-moi comme vous l'avez toujours fait ! N'employez pas un ton différent. Ne prenez pas un air solennel ou triste. Continuez à rire de ce qui nous faisait rire ensemble !  <br /><br />
                Priez, souriez, pensez à moi ! Que mon nom soit prononcé comme il l'a toujours été, sans emphase d'aucune sorte, sans une trace d'ombre !  <br /><br />
                La vie signifie tout ce qu'elle a toujours été : un grand voyage. Le fil n'est pas coupé. Pourquoi serais-je hors de vos pensées, simplement parce que je suis hors de votre vue ?  <br /><br />
                Je ne suis pas loin, juste de l'autre côté du chemin."   <br /><br />
                <span> <img src={p4} /></span>
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

